import * as React from "react";
import {Post} from "../types/Post";
import DefaultHeader from "../components/DefaultHeader";
import Layout from "../components/Layout";
import {graphql} from "gatsby";
import DisplayPage from "../views/Page/DisplayPage";

const SinglePage = ({data}) => {
	const post: Post = data.mdx;

	return (
		<Layout title={post.frontmatter.title}>
			<DefaultHeader
				backgroundClass="post-bg"
				title={post.frontmatter.title}
			/>
			<DisplayPage
				post={post}
			/>
		</Layout>
	);
};

export default SinglePage;

export const pageQuery = graphql`
	query SinglePageQuery($id: String!, $language: String!) {
		mdx(id: {eq: $id}) {
			frontmatter {
				author
				date
				description
				locale
				slug
				tags
				title
				ogImage {
					publicURL
				}
			}
			body
		}

		locales: allLocale(filter: {language: {eq: $language}}) {
			edges {
				node {
					ns
					data
					language
				}
			}
		}
	}
`;
